"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _ListModule = _interopRequireDefault(require("../../Module/ListModule"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const PrimusMeasure = ({
  title,
  description
}) => {
  return _react.default.createElement(_ListModule.default, {
    title: title,
    description: description
  });
};

var _default = PrimusMeasure;
exports.default = _default;
module.exports = exports.default;